module.exports = __webpack_public_path__ + "static/img/arrowdown.fcea428e.svg";